export default {"src":"/_next/static/media/line-05.18be9b0c.svg","height":77,"width":124,"blurWidth":0,"blurHeight":0};